/**
 * StickerMedia — figurinha WebP/PNG no chat.
 * onError → MediaFallback (paridade com ImageMedia; evita ícone quebrado + alt "Sticker").
 */
import React, { useEffect, useState } from 'react';
import { MediaInfo } from './types.js';
import { MediaFallback } from './MediaFallback.js';

interface StickerMediaProps {
    media: MediaInfo;
    status?: string;
}

export const StickerMedia: React.FC<StickerMediaProps> = ({ media, status }) => {
    const url = media.url;
    const [hasError, setHasError] = useState(() => !url);

    useEffect(() => {
        setHasError(!url);
    }, [url]);

    if (!url || hasError) {
        return <MediaFallback type="sticker" status={status} />;
    }

    return (
        <div className="p-2">
            <img
                src={url}
                alt="Figurinha"
                className="w-28 h-28 object-contain"
                style={{
                    imageRendering: 'auto',
                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                }}
                loading="lazy"
                decoding="async"
                referrerPolicy="no-referrer"
                onError={() => setHasError(true)}
            />
        </div>
    );
};
